import { useQuery } from '@tanstack/react-query';
import { ModelType } from 'types';
import { fetchWithType } from 'utils/api';
import { getAdminUrl, getApiToken } from 'utils/helpers';

function useModel(code?: string) {
  const { data, ...rest } = useQuery({
    queryKey: ['model', code],
    queryFn: async () => {
      return await fetchWithType<ModelType>(
        getAdminUrl() + '/api/model/' + code,
        {
          method: 'GET',
          headers: {
            Authorization: `Bearer ${getApiToken()}`,
          },
        },
      );
    },
    enabled: !!code,
  });
  return { model: data?.data, ...rest };
}

export default useModel;
